import { combineReducers } from 'redux'
import { formReducer, modelReducer } from 'react-redux-form'

import * as h2Api from '../../h2Api'
import {
  AWARD_FORM,
  AWARD_LISTING,
  CERTIFICATION_FORM,
  CERTIFICATION_LISTING,
  CONTACT_FORM,
  CONTACT_LISTING,
  EDITABLE_ADD_ID_TO_SECTION,
  EDITABLE_REMOVE_ID_TO_SECTION,
  EDITABLE_RESUME_INITIAL_LOAD,
  EDITABLE_RESUME_REPLACE_RESUME,
  EDITABLE_RESUME_UPDATE_RESUME,
  EDITABLE_SET_AS_SECTION,
  EDUCATION_FORM,
  EDUCATION_LISTING,
  EMPLOYMENT_FORM,
  EMPLOYMENT_LISTING,
  MILITARY_FORM,
  MILITARY_LISTING,
  OBJECTIVE_FORM,
  OBJECTIVE_LISTING,
  RESUME_CREATED,
  RESUME_LISTING_LOADED,
  RESUME_LOADED,
  RESUME_SAVE_PORTFOLIO,
  RESUME_SECTION_ITEM_TO_ADD,
  SKILL_FORM,
  SKILL_LISTING
} from '../../actions/resume'

const initialCreationForm = {
  title: ''
}
const initialUpdateForm = {}
const initialEmploymentHistoryForm = {
  occupation: '',
  onetSoc: '',
  company: '',
  city: '',
  state: '',
  startMonth: null,
  startYear: new Date().getFullYear(),
  endMonth: null,
  endYear: null,
  salary: null,
  description: '',
  statusTypeId: 0
}
const initialEducationHistoryForm = {
  institution: '',
  institutionId: '',
  concentration: '',
  instructionalProgramId: '',
  city: '',
  state: '',
  graduationYear: null,
  degreeTypeId: null,
  degreeType: '',
  description: '',
  statusTypeId: 0
}
const initialAwardForm = {
  year: 0,
  award: '',
  description: ''
}
const initialCertificationForm = {
  name: '',
  organization: '',
  issued: {},
  expires: {},
  description: ''
}
const initialSkillForm = {
  skill: ''
}
const initialObjectiveForm = {
  objective: ''
}
const initialMilitaryForm = {
  occupation: '',
  startMonth: null,
  startYear: new Date().getFullYear(),
  endMonth: null,
  endYear: null,
  branchOfServiceId: null
}
const initialDocumentFormatSelectionForm = {
  formattingId: null
}
const initialContactForm = {
  contactName: '',
  address: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
  phone: '',
  email: ''
}
const initialState = {
  awards: [],
  certifications: [],
  contacts: [],
  education: [],
  workExperience: [],
  formats: [],
  military: [],
  objective: [],
  resume: null,
  skills: []
}
const editableResumeReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESUME_SECTION_ITEM_TO_ADD:
      console.log(state, action)
      const newState3 = {
        ...state,
        [action.sectionKey]: [
          ...state[action.sectionKey]?.filter(f => f.id != action.item?.id),
          action.item
        ]
      }

      console.log('ADDING:', action, state, newState3)

      return newState3
    case EDITABLE_RESUME_REPLACE_RESUME:
      return {
        ...state,
        resume: action.resume
      }
    case EDITABLE_RESUME_INITIAL_LOAD:
      const newState = {
        ...state,
        ...action.resumeParts
      }

      return newState
    case EDITABLE_SET_AS_SECTION:
      return {
        ...state,
        resume: {
          ...state.resume,
          [action.sectionKey]: action.itemId
        }
      }
    case EDITABLE_ADD_ID_TO_SECTION:
      const resume = state.resume || {}

      if (resume[action.sectionKey]?.includes(action.itemId)) {
        return state
      }

      if (!resume[action.sectionKey]) {
        return {
          ...state,
          resume: {
            ...resume,
            [action.sectionKey]: [action.itemId]
          }
        }
      }

      return {
        ...state,
        resume: {
          ...resume,
          [action.sectionKey]: [...resume[action.sectionKey], action.itemId]
        }
      }
    case EDITABLE_REMOVE_ID_TO_SECTION:
      const newState2 = {
        ...state,
        resume: {
          ...state.resume,
          [action.sectionKey]:
            state.resume[action.sectionKey]?.filter(i => i != action.itemId) ?? []
        }
      }

      return newState2
    default:
      return state
  }
}
const reducers = combineReducers({
  editableResumeReducer,
  resumeListingRequest: h2Api.restReducer(RESUME_LISTING_LOADED),
  resumeRequest: h2Api.restReducer(RESUME_LOADED),
  renameResumeRequest: h2Api.restReducer(EDITABLE_RESUME_UPDATE_RESUME),
  createResumeRequest: h2Api.restReducer(RESUME_CREATED),
  awardFormRequest: h2Api.restReducer(AWARD_FORM),
  awardListingRequest: h2Api.restReducer(AWARD_LISTING),
  contactFormRequest: h2Api.restReducer(CONTACT_FORM),
  contactListingRequest: h2Api.restReducer(CONTACT_LISTING),
  employmentListingRequest: h2Api.restReducer(EMPLOYMENT_LISTING),
  educationListingRequest: h2Api.restReducer(EDUCATION_LISTING),
  skillFormRequest: h2Api.restReducer(SKILL_FORM),
  skillListingRequest: h2Api.restReducer(SKILL_LISTING),
  objectiveFormRequest: h2Api.restReducer(OBJECTIVE_FORM),
  objectiveListingRequest: h2Api.restReducer(OBJECTIVE_LISTING),
  militaryFormRequest: h2Api.restReducer(MILITARY_FORM),
  militaryListingRequest: h2Api.restReducer(MILITARY_LISTING),
  certificationFormRequest: h2Api.restReducer(CERTIFICATION_FORM),
  certificationListingRequest: h2Api.restReducer(CERTIFICATION_LISTING),
  educationFormRequest: h2Api.restReducer(EDUCATION_FORM),
  employmentFormRequest: h2Api.restReducer(EMPLOYMENT_FORM),
  resumeSavePortfolioRequest: h2Api.restReducer(RESUME_SAVE_PORTFOLIO),
  renameResumeForm: modelReducer('jobtools.resume.renameResumeForm', initialCreationForm),
  createResumeForm: modelReducer('jobtools.resume.createResumeForm', initialCreationForm),
  updateResumeForm: modelReducer('jobtools.resume.updateResumeForm', initialUpdateForm),
  objectiveForm: modelReducer('jobtools.resume.objectiveForm', initialObjectiveForm),
  contactForm: modelReducer('jobtools.resume.contactForm', initialContactForm),
  awardForm: modelReducer('jobtools.resume.awardForm', initialAwardForm),
  certificationForm: modelReducer(
    'jobtools.resume.certificationForm',
    initialCertificationForm
  ),
  educationHistoryForm: modelReducer(
    'jobtools.resume.educationHistoryForm',
    initialEducationHistoryForm
  ),
  employmentHistoryForm: modelReducer(
    'jobtools.resume.employmentHistoryForm',
    initialEmploymentHistoryForm
  ),
  militaryForm: modelReducer('jobtools.resume.militaryForm', initialMilitaryForm),
  skillForm: modelReducer('jobtools.resume.skillForm', initialSkillForm),
  documentFormatSelectionForm: modelReducer(
    'jobtools.resume.documentFormatSelectionForm',
    initialDocumentFormatSelectionForm
  ),
  forms: formReducer('jobtools.resume', {
    renameResumeForm: initialCreationForm,
    createResumeForm: initialCreationForm,
    awardForm: initialAwardForm,
    certificationForm: initialCertificationForm,
    educationHistoryForm: initialEducationHistoryForm,
    employmentHistoryForm: initialEmploymentHistoryForm,
    militaryForm: initialMilitaryForm,
    skillForm: initialSkillForm,
    objectiveForm: initialObjectiveForm,
    contactForm: initialContactForm,
    updateResumeForm: initialUpdateForm,
    documentFormatSelectionForm: initialDocumentFormatSelectionForm
  })
})

export default reducers
